<template>
  <div class="wrapper">
    <div class="video-background">
      <video 
        src="https://cdn.prod.website-files.com/6969fc09cabe1dde868c4467%2F697afc2379663531eefa187e_AproachVideoBanner3_mp4.mp4" 
        autoplay 
        loop 
        muted 
        playsinline
        class="background-video"
      ></video>
      <div class="video-overlay"></div>
    </div>

    <div class="form">
      <img src="@/assets/pricerium_logo.png" alt="Pricerium" class="formLogo" />
      <template v-if="!isKeycloakMode">
        <a-input
          :placeholder="$t('login.usernamePlaceholder')"
          size="large"
          v-model="username"
          @keydown.enter="validation && login()"
        >
          <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
        </a-input>
        <a-input-password
          :placeholder="$t('login.passwordPlaceholder')"
          size="large"
          v-model="password"
          @keydown.enter="validation && login()"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input-password>
        <a-button type="primary" :disabled="!validation" @click="login">
          {{ $t('login.loginButton') }}
        </a-button>
        <span v-if="error" class="error">{{ error }}</span>
      </template>
      <template v-else>
        <a-button
          size="large"
          type="primary"
          @click="loginWithKeycloak"
          class="keycloak-btn"
        >
          {{ $t('login.loginKeycloakButton') }}
        </a-button>
      </template>
    </div>
  </div>
</template>

<script>
import { getEnv } from '@/runtime-config';

export default {
  name: "Auth",
  data() {
    return {
      password: '',
      username: '',
      error: '',
      isKeycloakMode: getEnv('AUTH_MODE') === 'keycloak',
    };
  },

  computed: {
    validation() {
      return this.password && this.username;
    },
  },

  methods: {
    login() {
      const { password, username } = this;

      this.$http.post('/auth/login', { password, username })
          .then(async ({ data }) => {
            this.error = ''
            localStorage.setItem('AUTH', JSON.stringify({access_token: data.access_token, user_id: data.userId}));
            this.afterLogin();
          })
          .catch(() => {
            this.error = this.$t('login.invalidCredentials')
          });
    },
    loginWithKeycloak() {
        const redirectUri = encodeURIComponent(`${window.location.origin}/authorization`);

        window.location.href = getEnv('BACKEND_URL') ? `${getEnv('BACKEND_URL')}/auth/login?redirect_uri=${redirectUri}` : `/auth/login?redirect_uri=${redirectUri}`
    },
    afterLogin() {
        this.$http.get('/api/users/permissions')
            .then(({ data }) => {
                localStorage.setItem('userData', JSON.stringify(data))
            })
            .finally(() => {
                window.location.href = '/';
            });
    }
  },

  async created() {
      if (localStorage.getItem('AUTH')) {
          window.location.href = '/';
      }
  }
}
</script>

<style scoped>
.wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  padding: 200px 0;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
}

.video-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
}

.background-video {
  position: absolute;
  top: 50%;
  left: 45%;
  min-width: 120%;
  min-height: 120%;
  width: auto;
  height: auto;
  transform: translate(-50%, -50%) scale(1.2);
  object-fit: cover;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
.form {
  width: 600px;
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 50px 50px;
  border-radius: 20px;
  gap: 24px;
  text-align: center;
  position: relative;
  z-index: 2;
  backdrop-filter: blur(5px);
  margin-left: 80px;
}
.formLogo {
  width: 180px;
  height: 37px;
  object-fit: contain;
  margin: 0 auto;
}
@media only screen and (max-width: 600px) {
  .form {
    width: 100vw;
  }
}
.error {
  margin-top: -19px;
  margin-bottom: -30px;
  color: rgb(241, 51, 51);
}

.keycloak-btn {
    font-size: 18px;
    font-weight: 600;
}
</style>
